import React from "react";
import { Box, Typography, Chip, Slider, Avatar } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import { initialsOf } from "../utils/commentUtils";
import { avatarColorOf } from "../utils/avatarUtils";

const marksFor = (max) => {
  const step = max <= 100 ? 25 : 100;
  const marks = [];
  for (let value = 0; value <= max; value += step) {
    marks.push({ value, label: `${value}%` });
  }
  return marks;
};

const capacityColorOf = (value, max) => {
  const ratio = value / max;
  if (ratio >= 1) return "#ef4444";
  if (ratio > 0.66) return "#f97316";
  return "#22c55e";
};

// Shared per-person capacity slider (e.g. Project's "Capacity Allocation" section,
// or assigning a single project to an employee). `max` sets the slider's range.
function CapacitySlider({ name, value, onChange, max = 300 }) {
  const color = capacityColorOf(value, max);

  return (
    <Box
      mb={2}
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper"
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar sx={{ width: 26, height: 26, fontSize: 11, bgcolor: avatarColorOf(name) }}>
            {initialsOf(name)}
          </Avatar>

          <Typography sx={{ fontSize: 13, fontWeight: 600, color: "text.primary" }}>
            {name}
          </Typography>

          {value >= max && <WarningAmberRoundedIcon sx={{ fontSize: 16, color }} />}
        </Box>

        <Chip
          label={`${value}%`}
          size="small"
          sx={{ background: color, color: "#fff", fontWeight: 700, fontSize: 12 }}
        />
      </Box>

      <Slider
        value={value}
        onChange={onChange}
        min={0}
        max={max}
        step={5}
        marks={marksFor(max)}
        valueLabelDisplay="auto"
        sx={{
          color,
          "& .MuiSlider-thumb": {
            width: 16,
            height: 16,
            boxShadow: `0 0 0 4px ${color}22`
          },
          "& .MuiSlider-markLabel": {
            fontSize: 11,
            color: "text.secondary"
          },
          "& .MuiSlider-rail": {
            opacity: 0.25
          }
        }}
      />
    </Box>
  );
}

export default CapacitySlider;
